import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
import { NotificationBar } from './components/NotificationBar';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { MethodSection } from './components/MethodSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel('1169790921917254');
    trackPageView();
  }, []);
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <NotificationBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <HookSection data-id="element-3" />
      <PainSection data-id="element-4" />
      <RevelationSection data-id="element-5" />
      <MethodSection data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <OfferSection data-id="element-8" />

      <FAQSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <ClosingSection data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}